import { render, staticRenderFns } from "./pg_contact.vue?vue&type=template&id=2c9a903e"
import script from "./pg_contact.vue?vue&type=script&lang=js"
export * from "./pg_contact.vue?vue&type=script&lang=js"
import style0 from "./pg_contact.vue?vue&type=style&index=0&id=2c9a903e&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports